import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Headphones } from 'lucide-react';
import { HeroSearch } from './HeroSearch';
export function HeroSection() {
  return <section className="relative bg-gradient-to-br from-travel-blue-600 via-travel-blue-500 to-travel-turquoise-600 pt-12 pb-32 overflow-hidden" data-id="element-156">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-157">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-158">
          <defs data-id="element-159">
            <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse" data-id="element-160">
              <circle cx="1" cy="1" r="1" fill="white" data-id="element-161" />
            </pattern>
          </defs>
          <rect width="100" height="100" fill="url(#grid)" data-id="element-162" />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-163">
        {/* Hero Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-164">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-165">
            Holidays Booking With
            <span className="block text-travel-turquoise-300" data-id="element-166">TravelSewa</span>
          </h1>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-6 text-white/90" data-id="element-167">
            <div className="flex items-center gap-2" data-id="element-168">
              <ShieldCheck className="w-5 h-5 text-travel-turquoise-300" data-id="element-169" />
              <span className="text-sm font-medium" data-id="element-170">Free Cancellation</span>
            </div>
            <div className="w-px h-5 bg-white/30 hidden sm:block" data-id="element-171" />
            <div className="flex items-center gap-2" data-id="element-172">
              <Headphones className="w-5 h-5 text-travel-turquoise-300" data-id="element-173" />
              <span className="text-sm font-medium" data-id="element-174">24 Hour Support</span>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Search Bar Container - positioned to overlap */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8" data-id="element-175">
        <HeroSearch data-id="element-176" />
      </div>
    </section>;
}